import Vue from 'vue'
import GiftBag from './index.vue'

let instance // 实例对象
let seed = 1 // 计数
let giftbagConstructor = Vue.extend(GiftBag) // 构造函数
let giftbagObj = {
  show(options = {}) {
    if (instance) {
      instance.vm.visible = true
      return instance.vm
    }
    let id = `giftbag_${seed++}`
    instance = new giftbagConstructor({
      data: options,
    })
    instance.id = id
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
    instance.vm.visible = true
    instance.dom = instance.vm.$el
    // instance.dom.style['z-index'] = 999 + seed
    return instance.vm;

  },
  close() {
    if (instance) {
      instance.vm.visible = false
      // instance.vm.$destroy()
    }
  }
}

export default giftbagObj